import { render, staticRenderFns } from "./Footer_q.vue?vue&type=template&id=277802e2&scoped=true&"
import script from "./Footer_q.vue?vue&type=script&lang=js&"
export * from "./Footer_q.vue?vue&type=script&lang=js&"
import style0 from "./Footer_q.vue?vue&type=style&index=0&id=277802e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277802e2",
  null
  
)

export default component.exports